import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  HStack,
  Text,
  useDisclosure,
  useRadioGroup,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { strategiesApi } from "src/api";
import {
  CreateStrategyParams,
  EatOrderExampleType,
  SingleSideExampleType,
  StrategyKey,
  StrategyType,
  TradeDirection,
  VolumeExampleType,
} from "src/api/types";
import CButton from "src/component/CButton/CButton";
import CRadioCard from "src/component/CRadioCard";
import CSelect from "src/component/CSelect";
import { useExchangeInfoStore } from "src/store";
import { getPairName } from "src/store/utils";
import * as Yup from "yup";
import styles from "./index.module.scss";
import CInput from "src/component/CInput/CInput";
import { useState } from "react";
import { useExchangeAccounts } from "src/hook/useExchangeAccounts";
import React from "react";
import { pro } from "ccxt";
import CommonEatOrderForm from "src/component/StrategyForms/CommonEatOrderForm";

export default function EatOrderForm() {
  const store = useExchangeInfoStore();
  const exchanges = useExchangeAccounts();
  const [selectedExchangeAccountId, setSelectedExchangeAccountId] = useState<number | null>(null);

  const exchangeAccountOptions = exchanges.myExchangeAccounts.map((account) => {
    const exchange = store.exchanges.find((exchange) => exchange.id === account.exchangeId);
    const displayName = `${exchange ? exchange.name : "unknown"}: ${account.alias}`;
    return { value: account.id, label: displayName };
  });

  const pairOptions = store.spotPairs.map((pair) => ({
    value: pair.id,
    label: getPairName(pair.base, pair.quote),
  }));
  const sideOptions = [
    { value: TradeDirection.Buy, label: "吃买单" },
    { value: TradeDirection.Sell, label: "吃卖单" },
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  return (
    <Formik
      initialValues={{
        strategyName: "",
        pair: "",
        exchangeAccount: "",
        repeatIntervalMsMin: "10000",
        repeatIntervalMsMax: "20000",

        eatSide: "",
        topN: "",
        topNEatRatio: "",

        eatTotalAmount: "",

        rangeAmountMinPer: "",
        rangeAmountMaxPer: "",

        orderNumberPer: "",
        orderIntervalMsPer: "",
        eatPriceTrigger: "",
      }}
      validationSchema={Yup.object({
        pair: Yup.object().required("Required"),
        exchangeAccount: Yup.object().required("Required"),
        

        // eatSide: Yup.object().required("Required"),
        // topN: Yup.number().required("Required"),
        // topNEatRatio: Yup.number().required("Required"),
        // rangeAmountMinPer: Yup.number().required("Required"),
        // rangeAmountMaxPer: Yup.number().required("Required"),
        // orderNumberPer: Yup.number().required("Required"),
        // orderIntervalMsPer: Yup.number().required("Required"),
        // eatPriceTrigger: Yup.number().required("Required"),
      })}
      onSubmit={async (values) => {
        const payload: CreateStrategyParams<EatOrderExampleType> = {
          strategyName: values.strategyName,
          pairId: Number((values.pair as any).value),
          exchangeAccountId: Number((values.exchangeAccount as any).value),
          type: StrategyType.EatOrder,
          repeatIntervalMsMin: Number(values.repeatIntervalMsMin),
          repeatIntervalMsMax: Number(values.repeatIntervalMsMax),
          preference: {
            eatSide: (values.eatSide as any).value,
            topN: Number(values.topN),
            topNEatRatio: Number(values.topNEatRatio),
            eatTotalAmount: Number(values.eatTotalAmount),
            rangeAmountMinPer: Number(values.rangeAmountMinPer),
            rangeAmountMaxPer: Number(values.rangeAmountMaxPer),
            orderNumberPer: Number(values.orderNumberPer),
            orderIntervalMsPer: Number(values.orderIntervalMsPer),
            eatPriceTrigger: Number(values.eatPriceTrigger),
          },
        };
        try {
          const result = await strategiesApi.createStrategyV2(payload);
          window.location.href = `/strategies?tab=${StrategyKey.Eat}`;
        } catch (error) {
          alert("创建失败");
        }
      }}
    >
      {({ values, setFieldValue, submitForm }) => {
        return (
          <>
            <Form className={styles.form}>
              <Flex width="calc(100% - 20px)" flexDirection="column" gap={2}>
                <Flex alignItems="center" gap={2} mt={4}>
                  <CSelect
                    classname={styles.select}
                    label={"交易所账户"}
                    placeholder="交易所账户"
                    options={exchangeAccountOptions}
                    onChange={(value) => {
                      setFieldValue("exchangeAccount", value);
                      setSelectedExchangeAccountId((value as any).value);
                    }}
                  />
                </Flex>
                <Flex alignItems="center" gap={2} mt={2}>
                  <CSelect
                    classname={styles.select}
                    label={"交易对"}
                    placeholder="交易对"
                    options={pairOptions}
                    onChange={(value) => {
                      setFieldValue("pair", value);
                    }}
                  />
                </Flex>
                <Flex alignItems="center" gap={2} mt={2}>
                  <CSelect
                    classname={styles.select}
                    label={"交易方向"}
                    placeholder="交易方向"
                    options={sideOptions}
                    onChange={(value) => {
                      setFieldValue("eatSide", value);
                    }}
                  />
                </Flex>
                <CommonEatOrderForm styles={styles} />

                <Flex alignItems="center" gap={2} mt={4}>
                  <CButton name="确认创建" onClick={onOpen} />
                </Flex>
              </Flex>
            </Form>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    确认创建
                  </AlertDialogHeader>

                  <AlertDialogBody>确定立即创建机器人吗？</AlertDialogBody>

                  <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                      取消
                    </Button>
                    <Button
                      onClick={() => {
                        onClose();
                        submitForm();
                      }}
                      ml={3}
                    >
                      确定
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
          </>
        );
      }}
    </Formik>
  );
}
